import React from "react";
import NavbarContent from "../components/Navbar/navbar";
import SkillContent from "../components/Skill/skill";

export default function Skill(){
       return(
              <>
              <NavbarContent/>
              <SkillContent/>
              </>
       )
}